<template>
  <div class="chartsHeight">
    <van-row type="flex" justify="space-between" class="chartsTitle">
      <van-col span="10">{{chartdata.name}}</van-col>
      <van-col span="14" class="buttonChange timeButton">
        <button :class="{ choose:1===time }" @click="changeTime(1)">日</button>
        <button :class="{ choose:2===time }" @click="changeTime(2)">月</button>
        <button :class="{ choose:3===time }" @click="changeTime(3)">年</button>
      </van-col>
    </van-row>
    <van-row>
      <van-col span="24" v-show="shape===3 && time!==3">
        <div :style="{minHeight: '200px'}">
          <table class="table">
            <thead>
              <tr>
                <th>时间</th>
                <th>达成(万)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) of singleTable" :key="index">
                <td>{{item.time}}</td>
                <td>{{item.reach}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </van-col>
      <van-col span="24" v-show="shape===3 && time===3">
        <div :style="{minHeight: '200px'}">
          <table class="table">
            <thead>
              <tr>
                <th>时间</th>
                <th>达成(万)</th>
                <th>达成率(%)</th>
                <th>年同比(%)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) of yearTable" :key="index">
                <td>{{item.time}}</td>
                <td>{{item.reach}}</td>
                <td>{{item.rate}}</td>
                <td>{{item.onYear}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </van-col>
      <van-col span="24" v-show="shape!=3">
        <van-row type="flex" class="numTitle" v-if="time===3">
          <van-col span="8">
            <span></span>达成
          </van-col>
          <van-col span="8">
            <span :style="{border:'1px solid #FF8700'}"></span>达成率
          </van-col>
          <van-col span="8">
            <span :style="{border:'1px solid #33C7FE'}"></span>年同比
          </van-col>
        </van-row>
        <van-row
          type="flex"
          justify="space-between"
          :style="{color: '#333',fontSize:'.12rem',padding: '0 15px'}"
          v-if="time===3 && showFlag===true"
        >
          <van-col span="8">达成{{moneyget}}百万元</van-col>
          <van-col span="8" :style="{textAlign:'right'}">达成率{{moneygetrate}}%</van-col>
          <van-col span="8" :style="{textAlign:'right'}">年同比{{moneygetOnyear}}%</van-col>
        </van-row>
        <van-row
          type="flex"
          justify="space-between"
          :style="{color: '#333',fontSize:'.12rem',padding: '0 15px'}"
          v-if="time!=3 && showFlag===true"
        >
          <van-col span="12">达成{{moneyget}}万元</van-col>
        </van-row>
        <div id="myChart" :style="{height: '180px',padding: '0px 15px'}"></div>
      </van-col>
    </van-row>
    <van-row
      class="buttonChange buttonBottom"
      type="flex"
      justify="center"
      :style="{padding: '15px 0px'}"
    >
      <van-col span="6">
        <button :class="{ choose:1===shape }" @click="changeValue(1)">柱状图</button>
      </van-col>
      <van-col span="6">
        <button :class="{ choose:2===shape }" @click="changeValue(2)">折线图</button>
      </van-col>
      <van-col span="6">
        <button :class="{ choose:3===shape }" @click="changeValue(3)">表格</button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
// import axios from 'axios'
export default {
  name: 'Datacharts',
  data () {
    return {
      option: {},
      shape: 1,
      time: 2,
      curInt: null,
      showFlag: false,
      moneyget: '',
      moneygetrate: '',
      moneygetOnyear: '',
      dayxData: [],
      dayreachData: [],
      dayrateData: [],
      monthxData: [],
      monthreachData: [],
      monthrateData: [],
      yearxData: [],
      yearreachData: [],
      yearrateData: [],
      yearonYearData: [],
      dayTable: [],
      monthTable: [],
      yearTable: [],
      singlexData: [],
      singlereachData: [],
      singlerateData: [],
      singleTable: [],
      max1: '',
      max2: '',
      chartdata: {}
    }
  },
  methods: {
    getHomeInfo () {
      // axios.get('/api/charts.json')
      //   .then(this.getHomeInfoSucc)
      this.getHomeInfoSucc()
    },
    getHomeInfoSucc () {
      // if (res.status === 200 && res.data) {
      // this.chartdata = res.data.data[1]
      this.chartdata = {
        'id': '1',
        'name': '新单保费',
        'year': '8,204,735',
        'mouth': '130,993',
        'time': '2019-09-19 10:58:07',
        'rate': '达成率',
        'reach': '68%',
        'onYear': '同比',
        'onYearV': '8%',
        'riskCode': 1,
        'isFollow': 0,
        'flag': true,
        'data': {
          'month': [
            {
              'time': '2月',
              'reach': '97074',
              'rate': '',
              'onYear': null
            },
            {
              'time': '3月',
              'reach': '100948',
              'rate': '',
              'onYear': null
            },
            {
              'time': '4月',
              'reach': '105961',
              'rate': '',
              'onYear': null
            },
            {
              'time': '5月',
              'reach': '108301',
              'rate': '',
              'onYear': null
            },
            {
              'time': '6月',
              'reach': '115883',
              'rate': '',
              'onYear': null
            },
            {
              'time': '7月',
              'reach': '130994',
              'rate': '',
              'onYear': null
            }
          ],
          'year': [
            {
              'time': '2月',
              'reach': '654132',
              'rate': '38',
              'onYear': '34'
            },
            {
              'time': '3月',
              'reach': '842126',
              'rate': '41',
              'onYear': '38'
            },
            {
              'time': '4月',
              'reach': '1029655',
              'rate': '57',
              'onYear': '44'
            },
            {
              'time': '5月',
              'reach': '1230901',
              'rate': '62',
              'onYear': '49'
            },
            {
              'time': '6月',
              'reach': '1518429',
              'rate': '75',
              'onYear': '55'
            },
            {
              'time': '7月',
              'reach': '1649456',
              'rate': '',
              'onYear': '85'
            }
          ],
          'day': [
            {
              'time': '0725',
              'reach': '6272',
              'rate': '84',
              'onYear': '77'
            },
            {
              'time': '0726',
              'reach': '7049',
              'rate': '70',
              'onYear': '63'
            },
            {
              'time': '0727',
              'reach': '2345',
              'rate': '66',
              'onYear': '53'
            },
            {
              'time': '0728',
              'reach': '1529',
              'rate': '47',
              'onYear': '55'
            },
            {
              'time': '0729',
              'reach': '7352',
              'rate': '48',
              'onYear': '60'
            },
            {
              'time': '0730',
              'reach': '7582',
              'rate': '36',
              'onYear': '45'
            },
            {
              'time': '0731',
              'reach': '15111',
              'rate': '40',
              'onYear': '33'
            }
          ]
        }
      }
      this.time = 2
      this.shape = 1
      this.changeTime(2)
      this.getchartData()
      // }
    },
    drawCharts () {
      let that = this
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.setOption(this.option, true)
      window.onresize = function () {
        myChart.resize()
      }
      myChart.on('click', function (params) {
        // myChart.clear()
        that.curInt = params.dataIndex
        myChart.setOption(that.option, false)
      })
    },
    changeValue (index) {
      this.curInt = null
      this.showFlag = false
      this.moneyget = ''
      this.moneygetrate = ''
      this.shape = index
      this.drawLine()
    },
    changeTime (index) {
      this.curInt = null
      this.showFlag = false
      this.moneyget = ''
      this.moneygetrate = ''
      this.time = index
      if (this.time === 1) {
        this.singlexData = this.dayxData
        this.singlereachData = this.dayreachData
        this.singlerateData = this.dayreachData
        this.singleTable = this.dayTable
      } else if (this.time === 2) {
        this.singlexData = this.monthxData
        this.singlereachData = this.monthreachData
        this.singlerateData = this.monthreachData
        this.singleTable = this.monthTable
      }
      this.drawLine()
    },
    calmax (arr) {
      let max = 0
      arr.forEach((el) => {
        if (!(el === undefined || el === '')) {
          if (max < el) {
            max = el * 1.2
          }
        }
      })
      let maxint = Math.ceil(max / 9.5)
      let maxval = maxint * 10
      return maxval
    },
    numFormat (num) {
      let res = num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ','
        })
      })
      return res
    },
    getchartData () {
      let getData = this.chartdata.data
      let daydata = getData.day.concat()
      let monthdata = getData.month.concat()
      let yeardata = getData.year.concat()
      this.dayTable = daydata.reverse()
      this.monthTable = monthdata.reverse()
      this.yearTable = yeardata.reverse()
      this.dayxData = []
      this.dayreachData = []
      this.dayrateData = []
      this.monthxData = []
      this.monthreachData = []
      this.monthrateData = []
      this.yearxData = []
      this.yearreachData = []
      this.yearrateData = []
      this.yearonYearData = []
      for (let i = 0; i < getData.day.length; i++) {
        this.dayxData.push(getData.day[i].time)
        this.dayreachData.push(getData.day[i].reach)
        this.dayrateData.push(getData.day[i].rate)
      }
      for (let i = 0; i < getData.month.length; i++) {
        this.monthxData.push(getData.month[i].time)
        this.monthreachData.push(getData.month[i].reach)
        this.monthrateData.push(getData.month[i].rate)
      }
      for (let i = 0; i < getData.year.length; i++) {
        this.yearxData.push(getData.year[i].time)
        this.yearreachData.push(Math.round(getData.year[i].reach / 100))
        this.yearrateData.push(getData.year[i].rate)
        this.yearonYearData.push(getData.year[i].onYear)
      }
      this.singlexData = this.monthxData
      this.singlereachData = this.monthreachData
      this.singlerateData = this.monthrateData
      this.singleTable = this.monthTable
      this.drawLine()
    },
    drawLine () {
      let that = this
      this.max1 = this.calmax(this.yearreachData)
      this.max2 = this.calmax(this.yearrateData)
      if (this.shape === 1 && this.time !== 3) {
        // 日/月柱状图
        this.option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            formatter: function (params) {
              that.moneyget = that.numFormat(params[0].value)
              that.showFlag = true
            }
          },
          color: ['#3399FF'],
          grid: {
            top: '18%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              splitLine: {
                show: false
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#999',
                  fontSize: '12'
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#e1e1e1',
                  width: 1
                }
              },
              data: this.singlexData
            }
          ],
          yAxis: {
            type: 'value',
            name: '万元',
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#999',
                fontSize: '12'
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#999',
                width: 1
              }
            }
          },
          series: [
            {
              data: this.singlereachData,
              type: 'bar',
              barWidth: '50%',
              itemStyle: {
                emphasis: {
                  label: {
                    show: true,
                    position: 'top',
                    backgroundColor: '#fff',
                    textStyle: {
                      color: '#999',
                      fontSize: 12
                    }
                  }
                },
                normal: {
                  color: function (params) {
                    let key = params.dataIndex
                    if (key === that.curInt) {
                      return '#015FBC'
                    } else {
                      return '#3399FF'
                    }
                  }
                }
              }
            }
          ]
        }
        this.drawCharts()
      } else if (this.shape === 2 && this.time !== 3) {
        // 日/月折线
        this.option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            formatter: function (params) {
              that.moneyget = that.numFormat(params[0].value)
              that.showFlag = true
            }
          },
          color: ['#3399FF'],
          grid: {
            top: '18%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              splitLine: {
                show: false
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#999',
                  fontSize: '12'
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#e1e1e1',
                  width: 1
                }
              },
              data: this.singlexData
            }
          ],
          yAxis: {
            type: 'value',
            name: '万元',
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#999',
                fontSize: '12'
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#999',
                width: 1
              }
            }
          },
          series: [
            {
              data: this.singlereachData,
              type: 'line',
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#3399FF' },
                    { offset: 1, color: '#fff' }
                  ])
                }
              },
              itemStyle: {
                color: '#3399FF'
                // opacity: 0
              }
            }
          ]
        }
        this.drawCharts()
      } else if (this.shape === 1 && this.time === 3) {
        // 年 柱状图
        this.option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            formatter: function (params) {
              that.moneyget = that.numFormat(params[0].value)
              that.moneygetrate = params[1].value
              that.moneygetOnyear = params[2].value
              that.showFlag = true
            }
          },
          grid: {
            top: '18%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              splitLine: {
                show: false
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#999',
                  fontSize: '12'
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#e1e1e1',
                  width: 1
                }
              },
              data: this.yearxData
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '百万',
              min: 0,
              max: this.max1,
              splitNumber: 5,
              interval: this.max1 / 5,
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#999',
                  fontSize: '12'
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#999',
                  width: 1
                }
              }
            },
            {
              type: 'value',
              name: '%',
              min: 0,
              max: this.max2,
              splitNumber: 5,
              interval: this.max2 / 5,
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#999',
                  fontSize: '12'
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#999',
                  width: 1
                }
              }
            }
          ],
          series: [
            {
              data: this.yearreachData,
              type: 'bar',
              name: '达成',
              barWidth: '50%',
              itemStyle: {
                emphasis: {
                  label: {
                    show: true,
                    position: 'top',
                    backgroundColor: '#fff',
                    textStyle: {
                      color: '#999',
                      fontSize: 12
                    }
                  }
                },
                normal: {
                  color: function (params) {
                    let key = params.dataIndex
                    if (key === that.curInt) {
                      return '#015FBC'
                    } else {
                      return '#3399FF'
                    }
                  }
                }
              }
            },
            {
              name: '达成率',
              type: 'line',
              yAxisIndex: 1,
              itemStyle: {
                color: '#FF8700'
                // opacity: 0
              },
              data: this.yearrateData
            },
            {
              name: '年同比',
              type: 'line',
              yAxisIndex: 1,
              itemStyle: {
                color: '#33C7FE'
                // opacity: 0
              },
              data: this.yearonYearData
            }
          ]
        }
        this.drawCharts()
      } else if (this.shape === 2 && this.time === 3) {
        // 年折线
        this.option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            formatter: function (params) {
              that.moneyget = that.numFormat(params[0].value)
              that.moneygetrate = params[1].value
              that.moneygetOnyear = params[2].value
              that.showFlag = true
            }
          },
          grid: {
            top: '18%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              splitLine: {
                show: false
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#999',
                  fontSize: '12'
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#e1e1e1',
                  width: 1
                }
              },
              data: this.yearxData
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '百万',
              min: 0,
              max: this.max1,
              splitNumber: 5,
              interval: this.max1 / 5,
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#999',
                  fontSize: '12'
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#999',
                  width: 1
                }
              }
            },
            {
              type: 'value',
              name: '%',
              min: 0,
              max: this.max2,
              splitNumber: 5,
              interval: this.max2 / 5,
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#999',
                  fontSize: '12'
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#999',
                  width: 1
                }
              }
            }
          ],
          series: [
            {
              data: this.yearreachData,
              name: '达成',
              type: 'line',
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#3399FF' },
                    { offset: 1, color: '#fff' }
                  ])
                }
              },
              itemStyle: {
                color: '#3399FF'
                // opacity: 0
              }
            },
            {
              data: this.yearrateData,
              name: '达成率',
              type: 'line',
              yAxisIndex: 1,
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#FF8700' },
                    { offset: 1, color: '#fff' }
                  ])
                }
              },
              itemStyle: {
                color: '#FF8700'
                // opacity: 0
              }
            },
            {
              data: this.yearonYearData,
              name: '年同比',
              type: 'line',
              yAxisIndex: 1,
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#33C7FE' },
                    { offset: 1, color: '#fff' }
                  ])
                }
              },
              itemStyle: {
                color: '#33C7FE'
                // opacity: 0
              }
            }
          ]
        }
        this.drawCharts()
      } else {
        this.shape = 3
      }
    },
    drawTable () {}
  },
  computed: {
    getType () {
      return this.$store.state.entirety.type
    },
    getKind () {
      return this.$store.state.entirety.kind
    },
    getQuota () {
      return this.$store.state.entirety.quota
    }
  },
  watch: {
    getType () {
      this.$nextTick(() => {
        this.getHomeInfo()
      })
    },
    getKind () {
      this.$nextTick(() => {
        this.getHomeInfo()
      })
    },
    getQuota () {
      this.$nextTick(() => {
        this.getHomeInfo()
      })
    }
  },
  mounted () {
    this.getHomeInfo()
  }
}
</script>

<style lang="stylus" scoped>
.chartsHeight {
  margin-top: 0.1rem;
  height: 100%;
  background: #fff;
}

.chartsTitle {
  font-size: 0.18rem;
  font-weight: 600;
  height: 0.45rem;
  line-height: 0.45rem;
  padding: 0px 15px;
}

.numTitle {
  font-size: 0.12rem;
  margin-bottom: 0.15rem;
  padding-left: 0.15rem;

  span {
    display: inline-block;
    width: 0.35rem;
    height: 1px;
    border: 1px solid #3399FF;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.buttonChange {
  font-size: 0;
  text-align: right;
}

.buttonChange button {
  height: 0.26rem;
  line-height: 0.26rem;
  border: none;
  margin: 0;
  font-size: 0;
  font-size: 0.14rem;
  padding: 0 15px;
  color: #39f;
  background: none;
  border: 1px solid #39f;
  border-radius: 0.02rem;
}

.timeButton button {
  border: 1px solid #F2F2F2;
  color: #999;
}

.buttonChange .choose {
  background: #3399FF;
  border: 1px solid #3399FF;
  color: #fff;
  border-radius: 0.02rem;
}

.buttonBottom {
  text-align: center;
}

table {
  width: 100%;
}

table td, table th {
  font-size: 0.14rem;
  padding: 10px 0;
  text-align: center;
}

table thead {
  color: #333;
  background: #fafafc;
}

.table > tbody > tr > td {
  border-top: none;
}

.table > thead > tr > th {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/Charts.vue